<div class="mobile-overview-kacheln">
    <a class="mobile-overview-link" *ngFor="let speiseplan_id of mandant.speisePlanIds | keyvalue"
        [routerLink]="['/speiseplan-mandant', speiseplan_id.value.splanId]" routerLinkActive="_active"
        (click)="app_state_service.check_page_menu()" [routerLinkActiveOptions]="{exact:true}">
        <mat-icon>restaurant</mat-icon>
        <span>{{ speiseplan_id.value.bezeichnung }}</span>
    </a>
</div>